var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page forbit-cancel-tree" },
    [
      _c(
        "Modal",
        {
          staticClass: "page-modal",
          attrs: {
            width: "40%",
            "mask-closable": false,
            "footer-hide": true,
            title: _vm.$t("updateNewSip.setSecret"),
            "class-name": "vertical-center-modal",
          },
          model: {
            value: _vm.exportModal,
            callback: function ($$v) {
              _vm.exportModal = $$v
            },
            expression: "exportModal",
          },
        },
        [
          _c("div", { staticClass: "main-box margin-bottom-20" }, [
            _c("div", { staticClass: "secret-box" }, [
              _c("span", [_vm._v(_vm._s(_vm.$t("updateNewSip.secret")))]),
              _c(
                "div",
                { staticClass: "secret-input" },
                [
                  _c("Input", {
                    attrs: {
                      type: "text",
                      size: "large",
                      placeholder: _vm.$t("updateNewSip.secretTip"),
                      maxlength: "32",
                    },
                    model: {
                      value: _vm.secret,
                      callback: function ($$v) {
                        _vm.secret = $$v
                      },
                      expression: "secret",
                    },
                  }),
                  _c(
                    "h4",
                    [
                      _c("Icon", {
                        attrs: {
                          type: "md-information-circle",
                          ssize: "30",
                          color: "#fc7790",
                        },
                      }),
                      _vm._v(
                        " " + _vm._s(_vm.$t("updateNewSip.noSecretTip")) + " "
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _c(
              "div",
              { staticClass: "detailBackBtn" },
              [
                _c(
                  "Button",
                  {
                    attrs: { type: "default", size: "large" },
                    on: {
                      click: function ($event) {
                        return _vm.backBtn(0)
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("updateNewSip.ignore")))]
                ),
                _c(
                  "Button",
                  {
                    attrs: { type: "primary", size: "large" },
                    on: {
                      click: function ($event) {
                        return _vm.backBtn(1)
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("common.submit")))]
                ),
              ],
              1
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }